import React from 'react'

const Spinner = () => (
  <center className='mt-5'>
    <div className="spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </center>
)

export default Spinner